import parseISO from "date-fns/parseISO";
import React from "react";

import clsx from "clsx";
import Loader from "components/Loader";
import { useRacehorse360Api } from "hooks/api";
import { useMutationWithRefetch } from "hooks/useMutationWithRefetch";
import useStyles from "./styles";

export interface Props {
  isToday?: boolean;
  date: string;
  className?: string;
  onUpdate?: () => Promise<void>;
  onUpdateError?: () => void;
  selectedFacilityId: string;
  horseId: string;
}

const AvailableDate = (props: Props) => {
  const {
    isToday,
    selectedFacilityId,
    horseId,
    onUpdate,
    onUpdateError,
    date
  } = props;

  const classes = useStyles();

  const { useCreateWorkoutRequest } = useRacehorse360Api();

  const { mutateAsync: createWorkoutRequest } = useCreateWorkoutRequest();

  const createWorkoutRequestTransaction = useMutationWithRefetch({
    mutation: createWorkoutRequest,
    refetch: onUpdate,
    onError: onUpdateError
  });

  const isLoading = createWorkoutRequestTransaction.isLoading;

  const handleClick = () => {
    if (isLoading) return;

    createWorkoutRequestTransaction.run({
      date,
      facilityId: selectedFacilityId,
      horseId: horseId,
      getOptions: {
        select: [
          "id",
          "facility.name",
          "facility.code",
          "date",
          "status",
          "hasComment"
        ]
      }
    });
  };

  return (
    <div
      className={classes.root}
      onClick={handleClick}
      data-test-element="CALENDAR_DAY"
      data-test-state={"AVAILABLE"}
    >
      {isLoading && <Loader className={classes.loader} />}
      <span
        className={clsx(classes.date, {
          [classes.squared]: isToday
        })}
      >
        {parseISO(date).getDate()}
      </span>
    </div>
  );
};

export default React.memo(AvailableDate);
